import { mapActions, mapGetters } from 'vuex'
import ServiceLogin  from '@/services/service.login'
import { jwtDecode } from 'jwt-decode'
import store from '@/store'

const core = {
  data () {
    return {
      imageRoot: process.env.VUE_APP_IMAGE_ROOT,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'stateUser/isAuthenticated',
      contentTypes: 'stateConfigs/contentTypes',
      landerTypes: 'stateConfigs/landerTypes'
    })
  },
  methods: {
    ...mapActions({
      authenticate: 'stateUser/authenticate',
      logout: 'stateUser/logout'
    }),
    async signIn (_user) {
      let data = {
        email: _user.user,
        username: _user.user,
        password: _user.password
      }
      const result = await ServiceLogin.signinUser(data)

      if (result && result.data && result.data.token) {
        // Token and profile go through the Vuex action only — no direct
        // localStorage writes. The refresh token arrived as an httpOnly
        // cookie on this same response and is not readable here.
        await this.$store.dispatch('stateUser/login', {
          accessToken: result.data.token,
          user: {
            uid: result.data.uid,
            email: result.data.email,
            pid: result.data.pid,
            //role: result.data.role
          }
        })

        this.$router.push({ name: result.data.role })
        return true
      } else if (result && result.data && result.data.challengeName === 'NEW_PASSWORD_REQUIRED') {
        // Account is still on its temp password — hand the challenge back to
        // the caller so it can collect a new one and hit /v1/sec/new-password.
        return result.data
      } else {
        alert ('There was a problem logging in')
        return false
      }
    },
    formatBytes (bytes) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      const value = bytes / Math.pow(k, i);
      return `${value.toFixed(2)} ${sizes[i]}`;
    },
    navigateTo (_target, _query = null) {
      console.log(_target, _query)
      this.$router.push({name: _target})
    },
    inRole() {
      const token = store.getters['stateUser/accessToken']
      if (!token) return null
      try {
        const decoded = jwtDecode(token)
        return decoded.role || decoded['custom:role'] || null
      } catch (err) {
        return null
      }
    }
  }
}

export default core